import { render, staticRenderFns } from "./CJT.vue?vue&type=template&id=4c85f6b6&scoped=true&"
import script from "./CJT.vue?vue&type=script&lang=js&"
export * from "./CJT.vue?vue&type=script&lang=js&"
import style0 from "./CJT.vue?vue&type=style&index=0&id=4c85f6b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c85f6b6",
  null
  
)

export default component.exports